import { Stepper } from "./MuiStepConnector";
import { MuiButton } from "./MuiButton";
import { MuiTab } from "./MuiTab";
import { MuiTable } from "./MuiTable";
import { MuiIcon } from "./MuiIcon";
import { MuiPaper } from "./MuiPaper";
import { MuiPaginationItem } from "./MuiPaginationItem";
import { MuiOutlinedInput } from "./MuiOutlinedInput";
import { MuiCard } from "./MuiCard";
import { MuiAccordion } from "./MuiAccordion";
import { MuiPickersCalendarHeader } from "./MuiPickersCalendarHeader";
import { MuiIconButton } from "./MuiIconButton";
import { MuiPickersClockNumber } from "./MuiPickersClockNumber";
import { MuiInputBase } from "./MuiInputBase";
import { MuiFormLabel } from "./MuiFormLabel";
const overridesDark = {
  ...Stepper,
  ...MuiButton,
  ...MuiTab,
  ...MuiTable,
  ...MuiIcon,
  ...MuiPaper,
  ...MuiPaginationItem,
  ...MuiOutlinedInput,
  ...MuiCard,
  ...MuiAccordion,
  ...MuiPickersCalendarHeader,
  ...MuiIconButton,
  ...MuiPickersClockNumber,
  ...MuiInputBase,
  ...MuiFormLabel,
};
export default overridesDark;
